import withDraft from '@/utils/draftHelper';
import actions from '@/datasets/collections/constants';
import { updateCollectionDatasetsCount } from './state';

const addDatasetCollectionsSuccess = withDraft((draft, { items }) => {
  updateCollectionDatasetsCount(draft, items, 1);
});

const removeDatasetCollectionsSuccess = withDraft((draft, { collectionCode }) => {
  updateCollectionDatasetsCount(draft, [{ code: collectionCode }], 1, false);
});

export default {
  [actions.ADD_DATASET_COLLECTIONS_SUCCESS]: addDatasetCollectionsSuccess,
  [actions.REMOVE_DATASET_COLLECTION_SUCCESS]: removeDatasetCollectionsSuccess,
};
